module.exports = __webpack_public_path__ + "static/media/14UNEP2.e976fdb8.jpg";